
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/symitar-core-speaks-ai",
      function () {
        return require("private-next-pages/blog/symitar-core-speaks-ai/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/symitar-core-speaks-ai"])
      });
    }
  